var _PhotoUploadServiceInit_uploading, _PhotoUploadServiceInit_uploadingFile, _PhotoUploadServiceInit_uploadCommand;
import { __classPrivateFieldGet } from "tslib";
import { get, writable } from 'svelte/store';
import { PhotoUploadCommand } from '../../model/photo/command/PhotoUploadCommand';
class PhotoUploadServiceInit {
    constructor() {
        _PhotoUploadServiceInit_uploading.set(this, writable(false));
        _PhotoUploadServiceInit_uploadingFile.set(this, writable(null));
        _PhotoUploadServiceInit_uploadCommand.set(this, new PhotoUploadCommand());
    }
    get uploading() {
        return __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploading, "f");
    }
    get uploadingFile() {
        return __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploadingFile, "f");
    }
    async uploadByFile(imageFile) {
        if (get(__classPrivateFieldGet(this, _PhotoUploadServiceInit_uploading, "f"))) {
            console.error("it's already uploading");
            return;
        }
        __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploading, "f").set(true);
        __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploadingFile, "f").set(imageFile);
        try {
            const result = await __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploadCommand, "f").execute(imageFile);
            return {
                hash: result.hash,
                height: result.height,
                isForAdult: result.adult,
                mimeType: result.mimeType,
                regDate: new Date(result.regDate),
                tags: result.tag,
                url: result.url,
                viewer: 0,
                width: result.width,
            };
        }
        finally {
            __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploading, "f").set(false);
            __classPrivateFieldGet(this, _PhotoUploadServiceInit_uploadingFile, "f").set(null);
        }
    }
}
_PhotoUploadServiceInit_uploading = new WeakMap(), _PhotoUploadServiceInit_uploadingFile = new WeakMap(), _PhotoUploadServiceInit_uploadCommand = new WeakMap();
export const PhotoUploadService = new PhotoUploadServiceInit();
